<template>
  <fragment>
    <v-row class="mt-2">
      <v-col class="d-flex align-center" cols="12">
        <v-text-field
          v-model.lazy.trim="user.name"
          :disabled="!editable.name"
          :rules="[
            (v) => !!v || 'Ad Soyad alanı boş bırakılamaz',
            (v) => v?.length >= 3 || 'Ad Soyad alanı en az 3 karakter olmalı',
          ]"
          class="flex-grow-1"
          dense
          hide-details="auto"
          label="Ad Soyad"
          required
        ></v-text-field>
        <v-btn
          :color="editable.name ? 'primary' : 'grey'"
          :title="editable.name ? 'Düzenlemeyi Kapat' : 'Düzenle'"
          class="ml-2"
          icon
          small
          @click="toggleEdit('name')"
        >
          <v-icon>{{ editable.name ? "mdi-lock-open" : "mdi-pencil" }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex align-center" cols="12">
        <div class="flex-grow-1">
          <SMEmailTextfield
            :email="user.email ? user.email.email : ''"
            :isFormValid="isFormValid"
            :readonly="!editable.email"
            :user_id="user.id"
            @update:email="
              (email) => {
                if (user.email === null) {
                  user.email = { email };
                } else {
                  user.email.email = email;
                }
              }
            "
          />
        </div>
        <v-btn
          :color="editable.email ? 'primary' : 'grey'"
          :title="editable.email ? 'Düzenlemeyi Kapat' : 'Düzenle'"
          class="ml-2"
          icon
          small
          @click="toggleEdit('email')"
        >
          <v-icon>{{ editable.email ? "mdi-lock-open" : "mdi-pencil" }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-n5 justify-content-end align-items-end">
      <v-col cols="12" md="6">
        <span
          class="d-block"
          style="top: 1px; position: relative; color: rgba(0, 0, 0, 0.6)"
          >Doğum Tarihi</span
        >
        <custom-date-picker
          v-model="user.birth_date"
          :dateRestriction="'after'"
          :isFormValid="isFormValid"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-if="genders"
          v-model.lazy="user.gender"
          :items="genders"
          :rules="[(v) => !!v || 'Cinsiyet alanı boş bırakılamaz']"
          class="mb-1"
          hide-details="auto"
          item-text="translate"
          item-value="value"
          label="Cinsiyet"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mt-2" cols="6">
        <v-text-field
          v-if="!notCitizen"
          v-model.lazy="user.identity"
          :rules="[
            (v) => !!v || 'Kimlik Numarası alanı boş bırakılamaz',
            (v) => v?.length === 11 || 'Kimlik Numarası 11 haneli olmalıdır',
            (v) =>
              /^\d+$/.test(v) ||
              'Kimlik Numarası sadece rakamlardan oluşmalıdır',
            (v) => identityVerification(v),
          ]"
          dense
          hide-details="auto"
          label="Kimlik Numarası"
          maxLength="11"
        />
        <v-text-field
          v-else
          v-model.lazy="user.passport_number"
          :rules="[(v) => !!v || 'Pasaport Numarası alanı boş bırakılamaz']"
          dense
          hide-details="auto"
          label="Pasaport Numarası"
        />
      </v-col>
      <v-col cols="6">
        <v-switch
          v-model="notCitizen"
          color="primary"
          label="TC Vatandaşı Değilim"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row class="mt-n5">
      <v-col class="d-flex align-center" cols="12">
        <div class="flex-grow-1">
          <SMPhoneSelectbox
            :phone="user.phone"
            :readonly="!editable.phone"
            :validate-id="user.id"
            validatable
            @update:phone="(phone) => (user.phone = phone)"
          />
        </div>
        <v-btn
          :color="editable.phone ? 'primary' : 'grey'"
          :title="editable.phone ? 'Düzenlemeyi Kapat' : 'Düzenle'"
          class="ml-2"
          icon
          small
          @click="toggleEdit('phone')"
        >
          <v-icon>{{ editable.phone ? "mdi-lock-open" : "mdi-pencil" }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span v-if="isRegisterForm" class="text-body-1 font-weight-bold"
          >Lütfen güncel bilgilerinizi giriniz! Kişisel verileriniz
          <a
            :href="`${baseUrl}/storage/statics/Aydinlatma_Metni.pdf`"
            class="text-blue"
            target="_blank"
            @click.stop
          >
            Aydınlatma Metni </a
          >kapsamında işlenmektedir.</span
        >
      </v-col>
    </v-row>
  </fragment>
</template>

<script>
import CustomDatePicker from "@/view/content/components/CustomDatePicker.vue";
import SMEmailTextfield from "@/view/content/siliconmade/SM-Email-Textfield.vue";
import SMPhoneSelectbox from "@/view/content/siliconmade/SM-Phone-Selectbox.vue";

export default {
  components: {
    SMPhoneSelectbox,
    CustomDatePicker,
    SMEmailTextfield,
  },
  name: "Information",
  data() {
    return {
      genders: [],
      notCitizen: this.isUserCitizen,
      editable: {
        name: false,
        email: false,
        phone: false,
      },
    };
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    isFormValid: {
      type: Boolean,
      default: true,
    },
    isRegisterForm: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "user",
    event: "update:user",
  },
  methods: {
    toggleEdit(field) {
      this.$set(this.editable, field, !this.editable[field]);
    },
    identityVerification(value) {
      if (value?.length !== 11) {
        return "TC Numarası 11 haneli olmalıdır!";
      }

      if (!/^\d+$/.test(value)) {
        return "TC Numarası sadece rakamlardan oluşmalıdır!";
      }

      if (value.startsWith("0")) {
        return "TC Numarası 0 ile başlayamaz!";
      }

      const tc = value.split("").map(Number);

      // Tek ve çift hanelerin toplamı (ilk 9 rakam için)
      let odd = tc[0] + tc[2] + tc[4] + tc[6] + tc[8];
      let even = tc[1] + tc[3] + tc[5] + tc[7];

      let digit10 = (((odd * 7 - even) % 10) + 10) % 10;
      let digit11 = tc.slice(0, 10).reduce((a, b) => a + b, 0) % 10;

      if (tc[9] !== digit10 || tc[10] !== digit11) {
        return "Girilen TC numarası geçersiz bir numaradır!";
      }

      return true;
    },
  },
  mounted() {
    this.$apiService
      .get("/enums", { params: { enum: "gender_enum" } })
      .then((response) => {
        this.genders = response.data;
      });
  },
  watch: {
    user: {
      handler: function (val) {
        this.$emit("update:user", val);
      },
      deep: true,
    },
    notCitizen: {
      handler: function (val) {
        if (val) {
          this.user.identity = null;
        } else {
          this.user.passport_number = null;
        }
      },
    },
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
    isUserCitizen() {
      if (this.user.register_token === null) {
        return this.user.identity !== null;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.v-input--is-readonly input {
  color: black !important;
  opacity: 1 !important;
}
</style>
